import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Booking = lazy(() => import('../pages/booking/page'));
const BookingSuccess = lazy(() => import('../pages/booking/success/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/booking',
    element: <Booking />,
  },
  {
    path: '/booking/success',
    element: <BookingSuccess />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
